import PageNotFound from "../Components/PageNotFound";
function PageNotFoundContainer() {
  return (
    <>
      <PageNotFound />
    </>
  );
}
export default PageNotFoundContainer;
